var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-layout",
    { staticClass: "qortex-container" },
    [
      _c("div", { staticClass: "md-headline" }, [_vm._v("Qortex")]),
      _c(
        "div",
        [
          _c("md-switch", {
            model: {
              value: _vm.localNonLinearEnabled,
              callback: function($$v) {
                _vm.localNonLinearEnabled = $$v
              },
              expression: "localNonLinearEnabled"
            }
          }),
          _c(
            "md-button",
            {
              staticClass: "md-primary md-raised",
              attrs: { disabled: !_vm.localNonLinearEnabled },
              on: { click: _vm.openQortexDialog }
            },
            [_vm._v("Set Qortex")]
          )
        ],
        1
      ),
      _c(
        "md-dialog",
        {
          ref: _vm.dialogRef,
          attrs: {
            id: "general-form-wrapper",
            "md-click-outside-to-close": false
          }
        },
        [
          _c("md-dialog-title", [_vm._v("Qortex")]),
          _vm.openDialog
            ? _c(
                "md-dialog-content",
                [
                  _c(
                    "md-input-container",
                    [
                      _c("label", [_vm._v("Group ID")]),
                      _c("md-input", {
                        model: {
                          value: _vm.localQortexData.groupId,
                          callback: function($$v) {
                            _vm.$set(_vm.localQortexData, "groupId", $$v)
                          },
                          expression: "localQortexData.groupId"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "md-input-container",
                    [
                      _c("label", [_vm._v("Bundle ID")]),
                      _c("md-input", {
                        model: {
                          value: _vm.localQortexData.bundleId,
                          callback: function($$v) {
                            _vm.$set(_vm.localQortexData, "bundleId", $$v)
                          },
                          expression: "localQortexData.bundleId"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "md-input-container",
                    [
                      _c("label", [_vm._v("Marketplace ID")]),
                      _c("md-input", {
                        model: {
                          value: _vm.localQortexData.marketplaceId,
                          callback: function($$v) {
                            _vm.$set(_vm.localQortexData, "marketplaceId", $$v)
                          },
                          expression: "localQortexData.marketplaceId"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "md-input-container",
                    [
                      _c("label", [_vm._v("Store ID")]),
                      _c("md-input", {
                        model: {
                          value: _vm.localQortexData.storeId,
                          callback: function($$v) {
                            _vm.$set(_vm.localQortexData, "storeId", $$v)
                          },
                          expression: "localQortexData.storeId"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "btn-container" },
                    [
                      _c(
                        "md-button",
                        {
                          staticClass: "md-primary md-raised",
                          on: {
                            click: function($event) {
                              return _vm.saveQortexData()
                            }
                          }
                        },
                        [_vm._v("Save")]
                      ),
                      _c(
                        "md-button",
                        {
                          staticClass: "cancel-btn md-raised",
                          on: {
                            click: function($event) {
                              return _vm.closeDialog()
                            }
                          }
                        },
                        [_vm._v("Cancel")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b37cddfe", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b37cddfe","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/forms/QortexForm.vue
// module id = 818
// module chunks = 0